const Theme = {
  breakpoints: {
    s: "only screen and (min-width: 500px)",
    m: "only screen and (min-width: 750px)",
    l: "only screen and (min-width: 1200px)",
  },
}

export default Theme
